import React from 'react'
import parse from 'html-react-parser'
import Phone from '../../images/Phone.svg'
import Email from '../../images/Email.svg'
import Calendar from '../../images/Calendar.svg'
import Image from '../../function/Image'
import HubspotForm from '../../components/HubspotForm/HubspotForm'
function ContactForm({ hubspotForm }) {
    if (!hubspotForm) return null
    const {
        title,
        sideImage,
        portalId,
        formId,
        blockLayout,
        contactSection: { email, meeting, phone }
    } = hubspotForm

    const layout = {
        form: `${
            !blockLayout
                ? 'lg:col-start-6 lg:col-span-7'
                : 'lg:col-span-7 lg:row-start-1'
        }`,
        content: `${
            !blockLayout
                ? 'lg:col-start-1 lg:col-span-4'
                : 'lg:col-start-9 lg:col-span-4'
        }`
    }
    return (
        <div className="relative isolate z-[5] py-20 lg:pb-20 lg:pt-32 xl:pb-[156px] xl:pt-[185px]">
            <div className="container relative text-white">
                <div className="grid grid-cols-12 grid-rows-1">
                    <div
                        className={`${layout.content} col-span-12 mb-12 justify-items-center text-left text-dark_purple sm:px-8 md:px-0 xl:mb-0`}
                    >
                        <div className="mb-[21px] [&_a]:text-vivid_raspberry [&_a:hover]:no-underline [&>h2]:text-[26px] [&>h2]:leading-[26px] [&>h2]:xl:text-[42px] [&>h2]:xl:leading-[42px]">
                            {title && parse(title)}
                        </div>
                        <div className="relative z-10 mt-5 flex">
                            {meeting && (
                                <a
                                    href={meeting}
                                    target="_blank"
                                    className="mr-5 flex min-h-[150px] flex-col justify-end rounded-[8px] bg-white p-5 shadow-[0_10px_40px] shadow-dark_purple/10"
                                >
                                    <div className="flex aspect-square h-10 w-10 items-center justify-center rounded-full bg-gradient-to-tl from-aquamarine to-sea_serpent">
                                        <img src={Calendar} alt="icon" />
                                    </div>
                                    <span className="pre-header">
                                        Book a meeting
                                    </span>
                                </a>
                            )}
                            <div className="flex flex-col justify-end">
                                {phone && (
                                    <a
                                        href={`tel:${phone}`}
                                        target="_blank"
                                        className="flex"
                                    >
                                        <div className="flex aspect-square h-10 w-10 items-center justify-center rounded-full bg-gradient-to-tl from-aquamarine to-sea_serpent">
                                            <img src={Phone} alt="icon" />
                                        </div>
                                        <div className="ml-4 flex flex-col justify-center">
                                            <span className="pre-header leading-snug">
                                                Phone
                                            </span>
                                            <p className="leading-snug">
                                                {phone}
                                            </p>
                                        </div>
                                    </a>
                                )}
                                {email && (
                                    <a
                                        href={`mailto:${email}`}
                                        target="_blank"
                                        className="mt-5 flex"
                                    >
                                        <div className="flex aspect-square h-10 w-10 items-center justify-center rounded-full bg-gradient-to-tl from-aquamarine to-sea_serpent">
                                            <img src={Email} alt="icon" />
                                        </div>
                                        <div className="ml-4 flex flex-col justify-center">
                                            <span className="pre-header leading-snug">
                                                Email
                                            </span>
                                            <p className="leading-snug">
                                                {email}
                                            </p>
                                        </div>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${layout.form} col-span-12 text-dark_purple`}
                    >
                        <HubspotForm portalId={portalId} formId={formId} />
                    </div>
                </div>
            </div>
            <div className="side-image absolute -left-[200px] top-[50%] z-[-1] hidden w-1/2 xl:block">
                {sideImage && <Image {...sideImage} alt={title} />}
            </div>
        </div>
    )
}

export default ContactForm
